import config from '../config';
import { handleErrors } from 'api/util';

export async function apiLogin(
    username: string,
    password: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/login`, {
        method: 'POST',
        body: JSON.stringify({
            username,
            password
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiLogout(): Promise<Response> {
    return await fetch(`${config.backendUrl}/logout`, {
        method: 'GET'
    }).then(handleErrors);
}

export async function apiGetCurrentUser(): Promise<Response> {
    return await fetch(`${config.backendUrl}/users/current`, {
        method: 'GET'
    }).then(handleErrors);
}

export async function apiSearchCompanies(
    businessIdOrCompanyName: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/company/search`, {
        method: 'POST',
        body: JSON.stringify({
            businessIdOrCompanyName
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(handleErrors);
}

export async function apiGetKeyFigures(
    businessId: string,
    amount?: number
): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/company/${businessId}/keyfigures${
            amount ? '?amount=' + amount : ''
        }`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    ).then(handleErrors);
}

export async function apiSearchCompanyBasicData(
    businessId: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/company/basic/${businessId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    }).then(handleErrors);
}

export async function apiFetchDecisionMakers(
    businessId: string
): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/company/decisionmaker/${businessId}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    ).then(handleErrors);
}

export async function apiGetCompanyConcernInformation(
    businessId: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/company/concern/${businessId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    }).then(handleErrors);
}

export async function apiFetchBusinessIdHistory(
    businessId: string
): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/company/businessidhistory/${businessId}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    ).then(handleErrors);
}
export async function apiFetchManagementBoard(
    businessId: string
): Promise<Response> {
    return await fetch(
        `${config.backendUrl}/company/personincharge/${businessId}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    ).then(handleErrors);
}

export async function apiFetchAnalysisPdf(
    businessId: string,
    language: string,
    concern: string
) {
    return await fetch(
        `${config.backendUrl}/company/${businessId}/analysis?lang=${language}&concern=${concern}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/pdf'
            }
        }
    ).then(handleErrors);
}

export async function apiGetProtests(businessId: string): Promise<Response> {
    return await fetch(`${config.backendUrl}/company/protests/${businessId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    }).then(handleErrors);
}
